export const LanguageProficiency = {
  A1: 'A1',
  A2: 'A2',
  B1: 'B1',
  B2: 'B2',
  C1: 'C1',
  C2: 'C2',
} as const;
export type LanguageProficiency = (typeof LanguageProficiency)[keyof typeof LanguageProficiency];

export const LanguageCode = {
  Englisch: 'en',
  Mandarin: 'zh',
  Hindi: 'hi',
  Spanisch: 'es',
  Französisch: 'fr',
  Arabisch: 'ar',
  Bengalisch: 'bn',
  Russisch: 'ru',
  Portugiesisch: 'pt',
  Urdu: 'ur',
  Indonesisch: 'id',
  Deutsch: 'de',
  Japanisch: 'ja',
  Javanisch: 'jv',
  Koreanisch: 'ko',
  Telugu: 'te',
  Türkisch: 'tr',
  Tamil: 'ta',
  Vietnamesisch: 'vi',
  Tagalog: 'tl',
  Marathi: 'mr',
  Italienisch: 'it',
  Persisch: 'fa',
  Hausa: 'ha',
  Swahili: 'sw',
  Amharisch: 'am',
  Oromo: 'om',
  Igbo: 'ig',
  Malayalam: 'ml',
  Birmanisch: 'my',
  Oriya: 'or',
  Sindhi: 'sd',
  Usbekisch: 'uz',
  Sundanesisch: 'su',
  Rumänisch: 'ro',
  Paschtu: 'ps',
  Khmer: 'km',
  Turkmenisch: 'tk',
  Assamesisch: 'as',
  Singhalesisch: 'si',
  Zhuang: 'za',
  Kasachisch: 'kk',
  Tatarisch: 'tt',
  Somali: 'so',
  Dänish: 'dk',
  Finnisch: 'fi',
  Norwegisch: 'no',
  Schwedisch: 'sv',
  Niederländisch: 'nl',
  Polnisch: 'pl',
  Tschechisch: 'cs',
  Slowakisch: 'sk',
  Ungarisch: 'hu',
  Griechisch: 'el',
  Bulgarisch: 'bg',
  Ukrainisch: 'uk',
  Kroatisch: 'hr',
  Serbisch: 'sr',
  Bosnisch: 'bs',
  Mazedonisch: 'mk',
  Slowenisch: 'sl',
  Estnisch: 'et',
  Lettisch: 'lv',
  Litauisch: 'lt',
  Maltesisch: 'mt',
  Albanisch: 'sq',
  Armenisch: 'hy',
  Georgisch: 'ka',
  Isländisch: 'is',
  Färöisch: 'fo',
  Irisch: 'ga',
  Baskisch: 'eu',
  Katalanisch: 'ca',
} as const;

export type LanguageCode = (typeof LanguageCode)[keyof typeof LanguageCode];

export const DachCountryCodes = {
  Germany: 'DE',
  Switzerland: 'CH',
  Austria: 'AT',
} as const;

export type DachCountryCodes = (typeof DachCountryCodes)[keyof typeof DachCountryCodes];
